import { Component } from '@angular/core';
import {AppHeaderStates} from "../../../common/enums/AppHeaderStates";

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.css']
})
export class MasterComponent {

  protected readonly AppHeaderStates = AppHeaderStates;
}
